import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Container } from "react-bootstrap";

// Pages
import HomePage from "./pages/HomePage";
import PokemonPage from "./pages/PokemonPage";
import AboutPage from "./pages/AboutPage";

// Components
import Header from "./components/Header";

const App = () => {
  return (
    <Router>
      <Header />
      <Container>
        <Route exact path="/" component={HomePage} />
        <Route path="/pokemon/:id" component={PokemonPage} />
        <Route path="/about" component={AboutPage} />
      </Container>
    </Router>
  );
};

export default App;
